export const pt_BR = {
    translation: {
        b: {
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            send: 'Enviar',
            done: 'Concluído',
            close: 'Fechar',
            clear: 'Limpar',
            copy_link: 'Copiar link',
            export: 'Exportar',
            delete: 'Excluir',
            delete_confirm: 'Confirmar exclusão',
            duplicate: 'Duplicar',
            share: 'Compartilhar',
            sign_in: 'Entrar',
            sign_up: 'Cadastrar-se',
            email_address: 'Endereço de e-mail',
            yes: 'Sim',
            no: 'Não'
        },
        m_languages: {
            title: 'Idiomas',
            subtitle: 'Escolha um idioma'
        },
        m_feedback: {
            feature: {
                name: 'Solicitação de recurso',
                desc: 'Faltando um recurso de que você precisa? Conte pra gente — suas ideias importam'
            },
            feedback: {
                name: 'Feedback',
                desc: 'Seu feedback é muito importante para nós — deixe um recado rápido'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Obrigado pela sua sugestão!',
                desc: 'Agradecemos por dedicar um tempo para compartilhar suas ideias — isso nos ajuda a melhorar.'
            },
            feedback: {
                name: 'Obrigado pelo seu feedback!',
                desc: 'Agradecemos por dedicar um tempo para compartilhar suas ideias — isso nos ajuda a melhorar.'
            }
        },
        m_diagram_details: {
            name_place: 'Insira o nome do projeto',
            desc_place: 'Insira a descrição do projeto'
        },
        m_quick_share: {
            title: 'Compartilhar rápido',
            subtitle: '(Pelo link)'
        },
        m_export_img: {
            title: 'Exportar imagem'
        },
        m_export_code: {
            title: 'Exportar código {{db_engine}}',
            download_file: 'Baixar arquivo',
            copy_code: 'Copiar código'
        },
        m_sign_in_remind: {
            title: 'Obrigado por experimentar o DB Design',
            subtitle: 'Entre ou cadastre-se para aumentar o número máximo de tabelas, salvar diagramas e desbloquear mais recursos.'
        },
        m_sign_in_restrict: {
            title: 'Entre para fazer mais no app',
            subtitle: 'Entre ou cadastre-se para aumentar os limites de tabelas, salvar diagramas e desbloquear mais recursos.'
        },
        m_new_diagram: {
            title: 'Novo diagrama',
            subtitle: 'Escolha um mecanismo de banco de dados',
            open_diagram: 'Abrir diagrama'
        },
        m_keyboard_shortcuts: {
            title: 'Atalhos de teclado',
            ctrl_left: {
                title1: 'Controles',
                title2: '(Esquerda)',
                items: {
                    mouse_sel: 'Seleção com o mouse / Modo mão',
                    table: 'Tabela',
                    line: 'Linha',
                    area: 'Área',
                    note: 'Nota',
                    comment: 'Comentário',
                    pen: 'Lápis',
                    undo: 'Desfazer',
                    redo: 'Refazer'
                }
            },
            ctrl_top_left: {
                title1: 'Controles',
                title2: '(Canto superior esquerdo)',
                items: {
                    export_img: 'Exportar imagem',
                    search: 'Pesquisar',
                    editor_panel: 'Painel do editor'
                }
            },
            ctrl_bottom_right: {
                title1: 'Controles',
                title2: '(Canto inferior direito)',
                items: {
                    minimap: 'Minimapa',
                    zoom_in: 'Ampliar',
                    zoom_out: 'Reduzir',
                    zoom_100: 'Zoom 100%'
                }
            },
            ctx_tab: {
                title1: 'Menu de contexto',
                title2: '(Tabela)',
                items: {
                    dupl_tab: 'Duplicar tabela',
                    del_tab: 'Excluir tabela'
                }
            },
            ctx_del_tab: {
                title1: 'Menu de contexto',
                title2: '(Excluir tabela)',
                items: {
                    yes: 'Sim',
                    no: 'Não'
                }
            },
            ctx_tab_col: {
                title1: 'Menu de contexto',
                title2: '(Coluna)',
                items: {
                    add_col_below: 'Adicionar coluna abaixo',
                    focus_col_above: 'Mover o foco para a coluna acima',
                    focus_col_below: 'Mover o foco para a coluna abaixo',
                    move_col_up: 'Mover coluna para cima',
                    move_col_down: 'Mover coluna para baixo',
                    dupl_col: 'Duplicar coluna',
                    del_col: 'Excluir coluna'
                }
            },
            ctx_line: {
                title1: 'Menu de contexto',
                title2: '(Linha)',
                items: {
                    del_line: 'Excluir linha'
                }
            },
            ctx_area: {
                title1: 'Menu de contexto',
                title2: '(Área)',
                items: {
                    dupl_area: 'Duplicar área',
                    del_area: 'Excluir área'
                }
            },
            ctx_multi: {
                title1: 'Menu de contexto',
                title2: '(Multisseleção)',
                items: {
                    select_all: 'Selecionar todos os elementos',
                    create_area_for_select_els: 'Criar área para elementos selecionados',
                    dupl_select_els: 'Duplicar elementos selecionados',
                    del_select_els: 'Excluir elementos selecionados'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Seleção do mouse',
                table: 'Tabela',
                line: 'Linha',
                area: 'Área',
                note: 'Nota (em breve)',
                comment: 'Comentário (em breve)',
                pen: 'Lápis',
                undo: 'Desfazer',
                redo: 'Refazer'
            },
            ctrl_top_left: {
                logo: 'Nota: ambiente de testes',
                name: 'Informações do diagrama',
                editor: 'Editor (em breve)',
                search: 'Pesquisa (em breve)',
                export: 'Opções de exportação',
                view_mode: 'Modo de visualização',
                zoom_to_fit: 'Ajustar à tela'
            },
            ctrl_top_right: {
                feature_req: 'Solicitação de recurso',
                sign_in: 'Entrar',
                quick_share: 'Compartilhar rápido'
            },
            ctrl_bottom_right: {
                full_screen: 'Tela cheia',
                minimap: 'Minimapa',
                zoom_out: 'Reduzir',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Ampliar',
                info: 'Informações e recursos'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Padrão',
                        blue: 'Azul',
                        green: 'Verde',
                        red: 'Vermelho',
                        purple: 'Roxo',
                        violet: 'Violeta'
                    },
                    borders: {
                        none: 'Nenhuma',
                        solid: 'Sólida',
                        dashed: 'Tracejada',
                        dotted: 'Pontilhada'
                    },
                    color: 'Cor',
                    border: 'Borda',
                    description: 'Descrição',
                    description_table_place: 'Descrição da tabela',
                    description_column_place: 'Descrição da coluna',
                    description_line_place: 'Descrição da linha',
                    description_note_place: 'Descrição da nota',
                    description_area_place: 'Descrição da área',
                    description_pen_place: 'Descrição do lápis',
                    hide_menu: 'Ocultar menu',
                    show_menu: 'Mostrar menu'
                },
                tab_col: {
                    add_col_below: 'Adicionar coluna abaixo',
                    add_col_above: 'Adicionar coluna acima',
                    key: 'Key',
                    keys: {
                        none: 'Nenhuma',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Nenhum',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Mover coluna para baixo',
                    move_col_up: 'Mover coluna para cima',
                    more_functions: 'Mais funções'
                },
                line: {
                    change_connects: 'Alterar conectores',
                    connects: {
                        empty: 'Vazio',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: 'Filtrar elementos'
                },
                multi: {
                    filter: 'Filtrar seleção',
                    create_area: 'Criar área'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Completo',
            keys_only: 'Somente chaves',
            names_only: 'Somente nomes'
        },
        dropdown_ctrl_export: {
            export_img: 'Exportar imagem',
            export_code: 'Exportar código SQL'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Entrar',
            new_project: 'Novo projeto',
            keyboard_shortcuts: 'Atalhos de teclado',
            languages: 'Idiomas'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Feedback',
            keyboard_shortcuts: 'Atalhos de teclado',
            languages: 'Idiomas',
            homepage: 'Página inicial'
        },
        n: {
            default: 'Carregando…',
            file_ready_to_download: 'O arquivo está pronto para download',
            code_copied: 'O código foi copiado',
            link_copied: 'O link foi copiado',
            please_enter_message: 'Insira uma mensagem',
            invalid_email: 'E-mail inválido',
            something_wrong_contact: 'Algo deu errado. Tente recarregar a página ou fale conosco.',
            something_wrong: 'Algo deu errado. Tente recarregar a página.',
            sending: 'Enviando…',
            request_sent: 'A solicitação foi enviada. Obrigado!'
        }
    }
};

export const pt_BRMeta = {
    lang_origin: 'Português',
    lang_eng: 'Portuguese',
    lang_code: 'pt-BR',
};
